module.exports = __webpack_public_path__ + "static/desktop_layer-a8ceae1f1b8b831c9c21e800607cf840.png";